import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import AppErrorBoundary from './AppErrorBoundary';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </React.StrictMode>
);
